import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { environment } from '../../environments/environment';
import { CurrencyPipe } from '@angular/common';
import { CobrancasService } from './cobrancas.service';
import { HttpClient } from '@angular/common/http';
declare var $: any;

@Injectable({
  providedIn: 'root',
})
export class FunctionService {
  env;
  constructor(public cobradores: CobrancasService, public http: HttpClient) {
    this.env = environment;
  }

  dataTableOpts = {
    keys: false,
    select: {
      style: 'multi',
    },
    language: {
      info: 'Mostrando _START_ a _END_ de _TOTAL_ valores',
      search: 'Pesquisar:',
      lengthMenu: 'Mostrar _MENU_',
      paginate: {
        previous: "<i class='mdi mdi-chevron-left'>",
        next: "<i class='mdi mdi-chevron-right'>",
      },
    },
    drawCallback() {
      $('.dataTables_paginate > .pagination').addClass('pagination-rounded');
    },
  };

  arrangeDateDB(d) {
    const convertedDate = moment(d, 'DD/MM/YYYY').format('YYYY-MM-DDTHH:mm:ss');
    return convertedDate;
  }

  public maskMoney(valor: any) {
    const c = new CurrencyPipe('pt-BR');
    return c.transform(valor, 'R$');
  }

  public replaceNotNumber(n) {
    const r = parseFloat(
      n
        .toString()
        .trim()
        .replace(/[^0-9]+/g, '')
    );
    const v = r / 100;
    return parseFloat(v.toString());
  }

  arrangeDate(d) {
    const date = moment(d).toDate();
    return moment(d).format('DD/MM/YYYY');
  }

  validaSelected(title, text, type) {
    return new Promise(resolve => {
      if ($('.selected').length === 0) {
        resolve(false);
        return $.NotificationApp.send(title, text, 'top-right', 'rgba(0,0,0,0.2)', type);
      } else {
        resolve(true);
      }
    });
  }

  // async getCobrador(value: string, retornar: string, key: string) {
  //     const cobradores: any = await this.cobradores.getcobradores();
  //     for (const c of cobradores) {
  //         if (c[key] === value) {
  //             return c[retornar];
  //         }
  //     }
  //     return '?';
  // }

  async getCobrancaDashboard(cnpj, dataIni, dataFim, data) {
    let url = `${environment.cobranca}/dashboard-cobranca/${cnpj}/${dataIni}/${dataFim}/`;
    return new Promise(resolve => {
      this.http.post(url, data).subscribe(res => {
        resolve(res);
      });
    });
  }
}
